type ListFormatter = { format: (items: string[]) => string };
type ListFormatCtor = new (locale: string, options: { style: "long"; type: "conjunction" }) => ListFormatter;

/** "Ana, Bruno e Carla" / "Ana, Bruno, and Carla". Intl.ListFormat is missing from the project's TS lib. */
export function formatList(items: string[], locale: string): string {
  const ListFormat = (Intl as unknown as { ListFormat?: ListFormatCtor }).ListFormat;
  return ListFormat ? new ListFormat(locale, { style: "long", type: "conjunction" }).format(items) : items.join(", ");
}
